module.exports = __webpack_public_path__ + "static/img/id-card-back.9c9cd416.png";